/* eslint-disable @typescript-eslint/no-explicit-any */
import { gql, useMutation, useQuery } from '@apollo/client';
import { ClaimRequest } from '../../model/ClaimRequest';

// Seed the Map slice D - claimant-side GraphQL. The backend resolver
// (claim-request-resolver) owns all validation, the unclaimed-pin rule, and
// the pending-claim caps; these hooks are thin Apollo wrappers. The resolver
// returns plain object types (NOT the Strapi data/attributes envelope), so
// results are used directly with no flattenObj.

export const SUBMIT_CLAIM_REQUEST = gql`
  mutation submitClaimRequest(
    $storefrontId: ID!
    $roleAtBusiness: String!
    $contactEmail: String!
    $contactPhone: String
    $proofType: String!
    $proofUrl: String
    $proofNote: String
  ) {
    submitClaimRequest(
      storefrontId: $storefrontId
      roleAtBusiness: $roleAtBusiness
      contactEmail: $contactEmail
      contactPhone: $contactPhone
      proofType: $proofType
      proofUrl: $proofUrl
      proofNote: $proofNote
    ) {
      ok
      reason
      claim {
        id
        status
        storefrontId
      }
    }
  }
`;

export const MY_CLAIM_REQUESTS = gql`
  query myClaimRequests {
    myClaimRequests {
      id
      storefrontId
      storefrontName
      storefrontSlug
      status
      rejectReason
      reviewNote
      createdAt
      reviewedAt
    }
  }
`;

// Returns the mutate function directly (useCreateStorefront pattern). The
// caller awaits it and reads data.submitClaimRequest.{ok,reason,claim}.
export const useSubmitClaim = (): ((opts: any) => any) => {
  const [submit] = useMutation(SUBMIT_CLAIM_REQUEST);
  return submit;
};

// skip: only fetch when the page actually shows a claimable community pin to
// a signed-in user - everyone else pays nothing.
export const useMyClaimRequests = (skip: boolean) => {
  const { data, loading, error, refetch } = useQuery(MY_CLAIM_REQUESTS, {
    skip,
    fetchPolicy: 'cache-and-network'
  });
  return {
    claims: (data?.myClaimRequests || []) as ClaimRequest[],
    claimsLoading: loading,
    claimsError: error,
    claimsRefetch: refetch
  };
};
